import {
  Logo,
  Status,
  StatusProps,
} from '@insight-health-ai/roseate/components';
import { useTenant } from 'src/hooks/misc';
import { useGetCurrentPractitionerEntitlements } from 'src/hooks/settings';

export const WorkspaceLogo = () => {
  const tenant = useTenant();
  const getLogo = () => {
    if (tenant === 'OP') {
      const src = 'https://images.insighthealth.ai/office-practicum/logo.svg';
      return (
        <img
          src={src}
          width="auto"
          height="auto"
          className="w-full cursor-pointer contain"
          alt="Insight Logo"
        />
      );
    }

    if (tenant === 'OpenDr') {
      const src = 'https://images.insighthealth.ai/open-doctor/logo.png';
      return (
        <img
          src={src}
          width="auto"
          height="auto"
          className="w-full cursor-pointer mt-4 contain"
          alt="OpenDr Logo"
        />
      );
    }

    return <Logo compact />;
  };

  return (
    <div className="flex items-center justify-center relative max-w-[40px]">
      {getLogo()}
    </div>
  );
};

export const WorkspacePlan = ({ style }: { style?: React.CSSProperties }) => {
  const {
    isAuraPro,
    isAuraTeams,
    isAuraEnterprise,
    isAuraProTrial,
    isAuraProTrialExpired,
    isPLGUser,
  } = useGetCurrentPractitionerEntitlements();

  const getStatusProps = (): StatusProps | null => {
    if (isAuraEnterprise)
      return {
        appearance: 'success',
        label: 'ENTERPRISE',
      };
    if (isAuraTeams) return { appearance: 'info', label: 'TEAMS' };
    if (isAuraProTrial && !isAuraProTrialExpired)
      return {
        appearance: 'warning',
        label: 'PRO TRIAL',
      };
    if (isAuraPro) return { appearance: 'success', label: 'PRO' };
    if (isPLGUser) return { appearance: 'neutral', label: 'FREE' };
    return null;
  };

  const statusProps = getStatusProps();
  if (!statusProps) return null;
  return (
    <Status
      className="font-semibold"
      size="xs"
      {...statusProps}
      style={{ ...style, ...statusProps?.style }}
    />
  );
};
